/**
 * Placeholder data for the demo account, who has no campaign behind the
 * dashboard's Top Posts and creators-reach panels.
 */
import type {
  CampaignCreatorsReach,
  CampaignTopPost,
} from '@/interfaces/campaignKpis';

export const DUMMY_TOP_POSTS: CampaignTopPost[] = [
  {
    id: 'dummy-post-1',
    mediaType: 'reel',
    mediaKind: null,
    mediaUrl: null,
    downloadUrl: null,
    thumbnailUrl: null,
    previewUrl: null,
    creatorHandle: '@dennperez',
    followers: 16_100,
    rewarded: 5.78,
    views: 3_900,
  },
  {
    id: 'dummy-post-2',
    mediaType: 'reel',
    mediaKind: null,
    mediaUrl: null,
    downloadUrl: null,
    thumbnailUrl: null,
    previewUrl: null,
    creatorHandle: '@jhoselynhapolinar',
    followers: 7_500,
    rewarded: 1.89,
    views: 415,
  },
  {
    id: 'dummy-post-3',
    mediaType: 'reel',
    mediaKind: null,
    mediaUrl: null,
    downloadUrl: null,
    thumbnailUrl: null,
    previewUrl: null,
    // Long enough to exercise the handle truncation in the design.
    creatorHandle: '@its.alehandra.beauty',
    followers: 5_200,
    rewarded: 8.1,
    views: 407,
  },
  {
    id: 'dummy-post-4',
    mediaType: 'reel',
    mediaKind: null,
    mediaUrl: null,
    downloadUrl: null,
    thumbnailUrl: null,
    previewUrl: null,
    creatorHandle: '@laumissdoors',
    followers: 22_200,
    rewarded: 42.38,
    views: 1_100,
  },
  {
    id: 'dummy-post-5',
    mediaType: 'reel',
    mediaKind: null,
    mediaUrl: null,
    downloadUrl: null,
    thumbnailUrl: null,
    previewUrl: null,
    creatorHandle: '@its.alehandra.official',
    followers: 5_200,
    rewarded: 8.1,
    views: 407,
  },
];

/** Total posts behind the campaign, of which only the top few are shown. */
export const DUMMY_TOP_POSTS_TOTAL = 24;

export const DUMMY_CREATORS_REACH: CampaignCreatorsReach = {
  combinedFollowerReach: 5_000,
  creatorCount: 34,
  audienceCreatorCount: 34,
  lastSyncedAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  ageBands: [
    { label: '13-17', percent: 3 },
    { label: '18-24', percent: 26 },
    { label: '25-34', percent: 38 },
    { label: '35-44', percent: 19 },
    { label: '45-54', percent: 9 },
    { label: '55-64', percent: 3 },
    { label: '65+', percent: 2 },
  ],
  gender: { women: 71, men: 27, unspecified: 2 },
  hourlyActivity: [
    2, 1, 1, 2, 2, 3, 4, 5, 6, 8, 9, 11, 11, 10, 11, 13, 16, 23, 31, 41, 48, 50,
    46, 34,
  ],
  topCountries: [
    { label: 'FR', percent: 42 },
    { label: 'DE', percent: 14 },
    { label: 'BE', percent: 9 },
    { label: 'CH', percent: 7 },
    { label: 'GB', percent: 6 },
  ],
  topCities: [
    { label: 'Paris', percent: 18 },
    { label: 'Lyon', percent: 6 },
    { label: 'Marseille', percent: 4 },
    { label: 'Brussels', percent: 4 },
    { label: 'Bordeaux', percent: 3 },
  ],
};

/** Green ramp used by the audience bars, strongest first. */
export const REACH_GREENS = ['#00AA74', '#66CCAC', '#99DDC7', '#CCEEE3'];

/** Ramp colour by rank, so the leading value always reads strongest. */
export const rampByRank = (rank: number): string =>
  REACH_GREENS[Math.min(rank, REACH_GREENS.length - 1)];
